
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import InvoiceService from '@/services/invoice.service';


@Component
export default class SelectInvoiceModal extends Vue {
  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  selVisible = false;

  @Prop({ default: '' })
  kaId!: any;

  invoiceList: any[] = [];

  async init(res: any, invoiceCategory: string) {
    // console.log(invoiceCategory);
    if (invoiceCategory) {
      this.invoiceList = res.filter((item: any) => item.invoice_category == invoiceCategory);
    } else {
      this.invoiceList = res;
    }
    this.selVisible = true;
  }

  onClose() {
    this.selVisible = false;
  }

  onSelectInvoice(item: any) {
    this.$emit('changeInvoice', item);
    this.onClose();
  }
}
